export default "__VITE_ASSET__CApCoAD9__"